import PropertyConstants from '../constants/PropertyConstants';

const ActiveProduct = ({
  duration = '',
  expirationTimestamp = null,
  paidTimestamp = null,
  price = '',
  type = PropertyConstants.PRODUCT_TYPE_NAME_TO_ID.FREE,
} = {}) => ({
  duration: String(duration),
  expirationTimestamp: Number(expirationTimestamp),
  paidTimestamp: Number(paidTimestamp),
  price: String(price),
  type: Number(type),
});

const Description = ({
  title,
  subtitle,
  benefits = [],
}: {
  title?: string;
  subtitle?: string;
  benefits?: Array<unknown>;
}) => ({
  benefits: benefits.map((benefit) => benefit),
  title: String(title),
  subtitle: String(subtitle),
});

const Product = ({
  type = PropertyConstants.PRODUCT_TYPE_NAME_TO_ID.FREE,
  price = '',
  duration = '',
  description = {},
} = {}) => ({
  type: Number(type),
  price: String(price),
  duration: String(duration),
  description: Description(description),
});

const Freemium = ({ isEnabled = false, activeProduct = {}, products = [], isInBuildingGroup = false } = {}) => ({
  isEnabled: Boolean(isEnabled),
  activeProduct: ActiveProduct(activeProduct),
  products: products.length ? products.map(Product) : products,
  isInBuildingGroup: Boolean(isInBuildingGroup),
});

export default Freemium;

export type FreemiumProps = ReturnType<typeof Freemium>;
export type ActiveProductProps = ReturnType<typeof ActiveProduct>;
